<template>
  <div class="itemS sepBottom">
    <div class="row1">
      <div class="title S8" :class="hightLight?'C5':'T1'">【{{item.index===0?"内容介绍":"第"+item.index+"节"}}】
        {{ item.title }}
      </div>
      <img v-if="!item.isFree" class="lock"
           :src="require((hasPermission(resp.detail.detail.productId) && !isShrink) || item.isAvailable?'../../static/ic_unlock.png':'../../static/ic_lock.png')">
      <img class="play" :src="require(hightLight?'@/static/ic_playing.gif':'@/static/ic_play_white.png')">
    </div>
    <div class="row2">
      <img src="../../static/ic_time.png">
      <div class="S4 T3">{{ dayjs(item.duration * 1000).utc().format('HH:mm:ss') }}</div>
      <progress v-if="item.progress!==0&&item.duration!==0&&!item.isHightlight" :value="item.progress" :max="item.duration"></progress>
      <div v-if="item.progress!==0&&!item.isHightlight" class="T1 S4 progressLabel">
        {{
          item.duration ? '已看到' + Math.min(100,(item.progress) / item.duration * 100).toFixed(0) + '%' : ''
        }}
      </div>
      <div class="S4 T3 date">{{ dayjs(item.updateTime).format('MM-DD') }}</div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import {hasPermission} from "@/api/permission";
import {mapState} from "vuex";


dayjs.extend(utc)

console.log(dayjs, "+++++++")
export default {
  name: "CatelogItem",
  props: {
    item: {
      type: Object,
    },
    hightLight: {
      type: Boolean
    },
    isShrink: {
      type:Boolean,
      default: false
    }
  },
  methods: {
    dayjs,
    hasPermission
  },
  computed: {
    ...mapState('video', ['resp', 'currentVideo']),
  }
}
</script>

<style scoped>
.date {
  position: absolute;
  right: 0;
}

.row1 {
  display: flex;
  flex-direction: row;
  position: relative;
}

.lock {
  width: auto;
  height: 36px;
  margin-left: 30px;
  margin-right: 80px;
}

.play {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 0;
}

.itemS {
  padding: 44px 30px;
}

.title {

}

.row2 {
  position: relative;
  display: flex;
  flex-direction: row;
  margin-top: 44px;
  align-items: center;
}

.row2 img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}


progress {
  width: 100px;
  height: 6px;
  border-radius: 3px;
  /*custom*/
  margin-left: 29px;
}

/* 表示总长度背景色 */
progress::-webkit-progress-bar {
  background-color: #ebebeb;
  border-radius: 3px;
}

/* 表示已完成进度背景色 */
progress::-webkit-progress-value {
  background: #046bcc;
  border-radius: 3px;
}

.progressLabel {
  margin-left: 20px;
}
</style>